module.exports = __webpack_public_path__ + "img/note-red-warning.daadb554.svg";